// removed by extract-text-webpack-plugin
module.exports = {"la-notification-bar":"la-notification-bar___21gto","notification-message":"notification-message___3VGJ-","message-status":"message-status___3Gfbw","icon":"icon___1hNyD","message-body":"message-body___lZk86","message-headline":"message-headline___3p9M4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannerOutdatedBrowser/BannerOutdatedBrowser.scss
// module id = ibbh
// module chunks = 57